import { Box, Button, Grid, InputLabel, Typography } from "@material-ui/core";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import s from "./index.module.css";

const AvatarUpload = ({
  avatarPath,
  newAvatarPath,
  enableProfileDataEdition,
  setDataChanged,
  handleUploadedFiles,
  removeAvatar,
  deletingAvatar,
}) => {
  const globalTheme = useSelector((s) => s.globalTheme);
  const classes = useStyles();

  return (
    <Box>
      <Typography variant="h6">Zdjęcie profilowe:</Typography>
      <Grid item xs={12}>
        <InputLabel style={{ color: "black" }}>Aktualne zdjęcie:</InputLabel>
        <Box style={{ margin: "10px" }}>
          {avatarPath ? (
            <img
              className={s.avatarImg}
              src={`/org-media/files${avatarPath}`}
              alt="aktualne zdjęcie profilowe"
            />
          ) : (
            <span style={{ fontWeight: "bold" }}>Brak</span>
          )}
        </Box>
      </Grid>
      {newAvatarPath && (
        <Grid item xs={12}>
          <InputLabel style={{ color: "black" }}>Nowe zdjęcie: </InputLabel>
          <Box style={{ margin: "10px" }}>
            <img
              className={s.avatarImg}
              src={newAvatarPath}
              alt="nowe zdjęcie profilowe"
            />
          </Box>
        </Grid>
      )}
      {deletingAvatar && (
        <Grid item xs={12}>
          Zdjęcie zostanie usunięte po zapisaniu zmian.
        </Grid>
      )}
      <Button
        className="button is-primary"
        variant="contained"
        component="label"
        className={classes.fontSize}
        style={{
          backgroundColor:
            globalTheme === "high-contrast" ? "#000" : "lightgrey",
          color: globalTheme === "high-contrast" ? "#fff200" : "black",
          border: globalTheme === "high-contrast" && "1px solid #fff200",
        }}
        disabled={!enableProfileDataEdition}
      >
        {!avatarPath ? "Wgraj zdjęcie" : "Zmień zdjęcie"}
        <input
          type="file"
          hidden
          disabled={!enableProfileDataEdition}
          onChange={({ target: { files } }) => {
            setDataChanged(true);
            handleUploadedFiles(files);
          }}
        />
      </Button>
      {avatarPath && (
        <Button
          className="button is-primary"
          variant="contained"
          component="label"
          className={classes.fontSize}
          style={{
            backgroundColor:
              globalTheme === "high-contrast" ? "#000" : "lightgrey",
            color: globalTheme === "high-contrast" ? "#fff200" : "black",
            border: globalTheme === "high-contrast" && "1px solid #fff200",
          }}
          disabled={!enableProfileDataEdition}
          onClick={() => {
            setDataChanged(true);
            removeAvatar();
          }}
        >
          Usuń zdjęcie
        </Button>
      )}
    </Box>
  );
};

export default AvatarUpload;
